class HistorySlide {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    var historySwiper = new Swiper(".historySwiper", {
      // loop: true,
      slidesPerView: 1.6,
      centeredSlides: true,
      speed: 1000,
      breakpoints: {
        768: {
          grabCursor: true,
          allowTouchMove: true,
          slidesPerView: 4,
          initialSlide: 0,
          centeredSlides: false,
          loopAdditionalSlides: 0,
        }
      },
      navigation: {
        nextEl: ".js-history-next",
        prevEl: ".js-history-prev",
      },
      pagination: {
        el: ".historypagination",
        clickable: true
      }
    });
  }
}